import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IAuthResult } from '../auth-result.model';
import { CommandResult } from '@amdb/drone/shared/models';
import { NbAuthResult, NbAuthToken, NbPasswordAuthStrategy, NbTokenService } from '@nebular/auth';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AmdbLoginService {
    constructor(private httpClient: HttpClient,
        private authStrategy: NbPasswordAuthStrategy,
        private tokenService: NbTokenService) { }

        login(user: any): Promise<boolean> {
            return this.httpClient.post<boolean>('/api/v1/auth/login-token', user).toPromise();
        }

    processSocialAuthResult(res: CommandResult<IAuthResult>): void {
        const authResult = new NbAuthResult(
            true,
            res,
            null,
            [],
            [],
            this.authStrategy.createToken(res.data.token, false));

        this.processResultToken(authResult);
    }

    private processResultToken(result: NbAuthResult) {
        if (result.isSuccess() && result.getToken()) {
            return this.tokenService.set(result.getToken())
                .pipe(
                    map((token: NbAuthToken) => {
                        return result;
                    }),
                );
        }
    }
}
